import { Outlet } from 'react-router-dom';
import NavRail from './NavRail';
import { AccountProvider } from '../auth/AccountContext';

/**
 * AppShell — authenticated Obsidian shell: 80px NavRail (md+) / bottom nav
 * (mobile) + a scrollable main area that renders the routed view. Wraps the
 * outlet in AccountProvider so the rail avatar and Account/Plans/Settings
 * views share one `/account` fetch.
 */
export default function AppShell() {
  return (
    <AccountProvider>
      <div className="flex min-h-dvh bg-background text-on-surface">
        <NavRail />
        <main className="min-h-dvh min-w-0 flex-1 pb-[calc(4rem+env(safe-area-inset-bottom))] md:ml-[80px] md:pb-0">
          <Outlet />
        </main>
      </div>
    </AccountProvider>
  );
}
